import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/Sala_de_espera.svg'


const _hoisted_1 = {
  id: "modal-plugin-certificate-password",
  class: "modal modal-md fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body py-3" }
const _hoisted_5 = { class: "container user-select-none" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = ["checked"]
const _hoisted_8 = ["checked"]
const _hoisted_9 = { class: "modal-footer py-3" }
const _hoisted_10 = ["disabled"]

import { Modal } from 'bootstrap'

  import { ref, onMounted, computed, watch } from 'vue'

  import Icon from '@/components/Atoms/Icon.vue'
  import { useModalControl } from '../store/pinia/useModalControl.store'
  import usePluginCertificatePasswordTipModal from '../composables/usePluginCertificatePasswordTipModal'
  import ModalPluginCertificatePasswordTip from './ModalPluginCertificatePasswordTip.vue'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ModalPluginCertificatePassword',
  emits: ['chosePasswordConfirm'],
  setup(__props, { expose: __expose, emit: __emit }) {

  const emit = __emit

  const modal = ref<InstanceType<typeof Modal> | null>(null)

  const { pluginCertificatePasswordTipModal } =
    usePluginCertificatePasswordTipModal()

  const useDifferentPassword = ref<boolean>(false)

  const useSamePassword = ref<boolean>(false)

  const hasOptionsSelected = computed(
    () => useDifferentPassword.value || useSamePassword.value,
  )

  onMounted(() => {
    modal.value = new Modal('#modal-plugin-certificate-password', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  function hide() {
    modal.value?.hide()
  }

  function show() {
    useSamePassword.value = false
    useDifferentPassword.value = false
    modal.value?.show()
  }

  watch(useDifferentPassword, (value) => {
    if (value) {
      useSamePassword.value = false
    }
  })

  watch(useSamePassword, (value) => {
    if (value) {
      useDifferentPassword.value = false
    }
  })

  async function advanceNextStep(): Promise<void> {
    const modalControlStore = useModalControl()
    const {
      hidePluginCertificatePasswordTip,
      showPluginCertificatePasswordTip,
    } = usePluginCertificatePasswordTipModal()

    hide()

    return modalControlStore.show({
      modalId: 'pluginCertificatePasswordTipModal',
      hide: hidePluginCertificatePasswordTip,
      show: showPluginCertificatePasswordTip,
    })
  }

  function resendEmit() {
    emit('chosePasswordConfirm')
  }

  __expose({ hide, show })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", { class: "modal-header pb-3 border-bottom" }, [
            _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "modal-title plugin-modal-title" }, "Falta pouco!", -1)),
            _createElementVNode("button", {
              class: "btn-close",
              onClick: hide
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("img", {
              class: "d-block mx-auto img-container",
              src: _imports_0,
              alt: "Menina com xícara de café com um desenho de coração"
            }, null, -1)),
            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "fs-6 text-start mt-4" }, [
              _createElementVNode("strong", null, " Para utilizar seu Certificado Digital, o que você prefere? ")
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "form-check d-flex w-100",
                  onClick: _cache[0] || (_cache[0] = () => (useDifferentPassword.value = !useDifferentPassword.value)),
                  onKeypress: () => null
                }, [
                  _createElementVNode("input", {
                    type: "radio",
                    class: "form-check-input form-check-input--success square-circle-container",
                    checked: !useSamePassword.value && useDifferentPassword.value
                  }, null, 8, _hoisted_7),
                  _cache[3] || (_cache[3] = _createElementVNode("label", { class: "form-check-label ms-3 label-text-left" }, " Criar uma senha para uso do Certificado. ", -1))
                ], 32),
                _createElementVNode("div", {
                  class: "form-check d-flex",
                  onClick: _cache[1] || (_cache[1] = () => (useSamePassword.value = !useSamePassword.value)),
                  onKeypress: () => null
                }, [
                  _createElementVNode("input", {
                    type: "radio",
                    class: "form-check-input form-check-input--success square-circle-container",
                    checked: !useDifferentPassword.value && useSamePassword.value
                  }, null, 8, _hoisted_8),
                  _cache[4] || (_cache[4] = _createElementVNode("label", { class: "form-check-label ms-3 label-text-left" }, " Manter a senha de emissão para o uso do Certificado. ", -1))
                ], 32)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn", [!hasOptionsSelected.value ? 'btn-secondary' : 'btn-primary']]),
              type: "button",
              disabled: !hasOptionsSelected.value,
              onClick: advanceNextStep
            }, [
              _cache[7] || (_cache[7] = _createElementVNode("span", null, "Avançar", -1)),
              _createVNode(Icon, {
                class: "ms-2",
                name: "arrow-right"
              })
            ], 10, _hoisted_10)
          ])
        ])
      ])
    ]),
    _createVNode(ModalPluginCertificatePasswordTip, {
      ref_key: "pluginCertificatePasswordTipModal",
      ref: pluginCertificatePasswordTipModal,
      "is-different-pass": useDifferentPassword.value,
      onChosePasswordConfirm: resendEmit
    }, null, 8, ["is-different-pass"])
  ], 64))
}
}

})